const { q } = require('../helpers.js');

export const divWrapper = q('#divWrapper');
export const btnDownloadOffer = q('#btnDownloadOffer');
export const lblOfferValidity = q('#lblOfferValidity');
export const lblOfferInstallments = q('#lblOfferInstallments');
export const lblOfferDD = q('#lblOfferDD');
export const lblOfferPrice = q('#lblOfferPrice');
export const lblOfferDDPrice = q('#lblOfferDDPrice');
export const lblOfferFIPrice = q('#lblOfferFIPrice');
export const lblOfferPriceMobile = q('#lblOfferPriceMobile');
export const lblOfferDDPriceMobile = q('#lblOfferDDPriceMobile');
export const lblOfferFIPriceMobile = q('#lblOfferFIPriceMobile');
export const btnOffer6M = q('#btnOffer6M');
export const btnOffer12M = q('#btnOffer12M');
export const btnOfferCustomM = q('#btnOfferCustomM');
// export const divOfferInstallments = q('#divOfferInstallments');
export const divOfferValidity = q('#divOfferValidity');
export const divOfferDD = q('#divOfferDD');
export const promoTextCar = q('#divOfferDD .promo-text-car');
export const promoLinkCar = q('#divOfferDD .promo-link-car');

export const lblOfferBonusMalus = q('#lblOfferBonusMalus');
export const btnOfferBack = q('#btnOfferBack');
export const btnOfferNext = q('#btnOfferNext');